import mAxios from './m-axios'
import {newUser, User} from './user'

// export interface CourseOutline{
//   id:number
//   tags:string
//   name:string
//   desc:string
//   mark:string
//   duration:string
//   grade_id?:number
//   key?:string
// }

export interface Lesson {
  id: number
  name: string
  desc: string
  image: string
  sort: number
  renderSort?: string
  tags?: string
  avatar?: string
  coursewares?: LessonAnnex[]
  lesson_plans?: LessonAnnex[]
  videos?: LessonAnnex[]
  codes?: LessonAnnex[]
  exams?: LessonAnnex[]
  recommendations?: LessonAnnex[]
  grade_id?: number
  key?: number
  unit?: string
  key_point?: string
  type?: number
  duration?: string
  tools: string
}

export interface LessonAnnex {
  lesson_id: number
  lesson_annex_id: string
  key?: string
  type: string
  url: string
  preview_url: string
  image: string
  author: User
  name: string
  suffix: string
  updated_at: string
  should_update_preview?: boolean
}

// export const newCourseOutline = ():CourseOutline => ({
//   id:0,
//   tags:'',
//   name:'',
//   desc:'',
//   mark:'',
//   duration:''
// })

export const newCourse = (): Lesson => ({
  id: 0,
  name: '',
  desc: '',
  tags: '',
  avatar: '',
  coursewares: [],
  lesson_plans: [],
  videos: [],
  codes: [],
  exams: [],
  recommendations: [],
  image: '',
  sort: 0,
  duration: '',
  tools: '',
})

export const newCourseAnnex = (): LessonAnnex => ({
  lesson_id: 0,
  lesson_annex_id: '',
  type: '',
  url: '',
  preview_url: '',
  image: '',
  author: newUser(),
  updated_at: new Date().toISOString(),
  name: '',
  suffix: '',
})

export const listCourse = (lesson_group_ids: number[], type: number) => {
  return mAxios({
    method: 'get',
    url: '/api/grade/lesson',
    params: {
      lesson_group_ids: JSON.stringify(lesson_group_ids),
      type: type,
    },
  }).then(res => res.data)
}

export const listLessonAnnex = (lesson_id: number) => {
  return mAxios({
    method: 'get',
    url: '/api/lesson/annex',
    params: {
      lesson_id: lesson_id,
    },
  }).then(res => res.data)
}

export const addCourseAnnex = (annex: LessonAnnex) => {
  return mAxios({
    method: 'post',
    url: '/api/course/annex',
    data: annex,
  }).then(res => res.data)
}

export const delCourseAnnex = (id: string) => {
  return mAxios({
    method: 'delete',
    url: '/api/course/annex',
    data: {
      course_annex_id: id,
    },
  }).then(res => res.data)
}

export const updateCourseAnnex = (annex: LessonAnnex) => {
  return mAxios({
    method: 'put',
    url: '/api/course/annex',
    data: annex,
  }).then(res => res.data)
}
